module.exports = __webpack_public_path__ + "static/media/wig-logo.ccda7e82.png";